import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import Table from "../../components/table/Table";
import Page from "../../components/table/paging";
import ExcelJS from "exceljs";
import GAMEAPI from "../../api/game";
import { Header } from "../../components/table/interface/interface";
import FileSaver from "file-saver";
import ButtonStyle from "../../components/style/button.component";

const GameCouponList = () => {
  const [list, setList] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [usageFilter, setUsageFilter] = useState<string>("all"); // 사용여부 필터 상태 추가

  const headers = [
    {
      text: "couponId",
      align: "start",
      sortable: false,
      value: "couponId",
    },
    {
      text: "쿠폰코드",
      align: "start",
      sortable: false,
      value: "code",
    },
    {
      text: "쿠폰종류",
      align: "start",
      sortable: false,
      value: "couponType",
    },
    {
      text: "사용여부",
      align: "start",
      sortable: false,
      value: "isUse",
    },
    {
      text: "사용자",
      align: "center",
      sortable: false,
      value: "nickname",
    },
    {
      text: "메모",
      align: "center",
      sortable: false,
      value: "tag",
    },
    {
      text: "쿠폰타입",
      align: "center",
      sortable: false,
      value: "type",
    },
    {
      text: "쿠폰 보상",
      align: "center",
      sortable: false,
      value: "reward",
    },
    {
      text: "만료일시",
      align: "center",
      sortable: false,
      value: "endedAt",
    },
    {
      text: "추가일시",
      align: "center",
      sortable: false,
      value: "addedAt",
    },
  ];

  const exportToExcel = async (headers: Header[]) => {
    let items: any[] = [];
    const today = new Date().toISOString().split("T")[0];
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data");
    for (let i = 0; i < totalPages; i++) {
      const res = await GAMEAPI.getCouponList(i);
      items.push(...res.data.payload.list);
    }
    // 헤더 행 추가
    worksheet.addRow(headers.map((header) => header.text));

    // 데이터 행 추가
    items.forEach((item: any) => {
      const rowValues = headers.map((header) => {
        if (header.value === "createdAt") {
          return item[header.value].split("T")[0];
        } else {
          return item[header.value];
        }
      });
      worksheet.addRow(rowValues);
    });

    // 엑셀 파일 생성 및 다운로드
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, "all_report_" + today + ".xlsx");
  };

  const getCouponList = async (page: number, resetList: boolean = false) => {
    // 필터 조건에 따른 검색 옵션 설정
    const searchOption = usageFilter !== "all" ? "isUse" : "";
    const searchText =
      usageFilter === "used" ? "1" : usageFilter === "unused" ? "0" : "";

    const res = await GAMEAPI.getCouponList(page, searchOption, searchText);
    setTotalPages(Math.ceil(res.data.payload.totalCount / 20));

    if (resetList) {
      // 필터 변경 시 리스트 초기화
      setList(
        res.data.payload.list.map((item: any) => ({
          ...item,
          couponType: item.isCommon ? "공통" : "개인",
          type: item.type.length > 0 ? item.type : "중복사용가능",
          isUse: item.isUse ? "사용" : "미사용",
          reward: `포인트: ${item.rewardList.point}, 리바인: ${item.rewardList.rebuyinTicket}`,
        }))
      );
    } else {
      // 페이지 변경 시 기존 리스트에 추가
      setList((prevList) => {
        const existingCouponIds = new Set(
          prevList.map((item) => item.couponId)
        );
        const newItems = res.data.payload.list
          .filter((item: any) => !existingCouponIds.has(item.couponId))
          .map((item: any) => ({
            ...item,
            couponType: item.isCommon ? "공통" : "개인",
            type: item.type.length > 0 ? item.type : "중복사용가능",
            isUse: item.isUse ? "사용" : "미사용",
            reward: `포인트: ${item.rewardList.point}, 리바인: ${item.rewardList.rebuyinTicket}`,
          }));

        return [...prevList, ...newItems];
      });
    }
  };

  // 필터 변경 핸들러
  const handleFilterChange = (filterValue: string) => {
    setUsageFilter(filterValue);
    setCurrentPage(1);
    setList([]);
  };

  useEffect(() => {
    getCouponList(currentPage - 1, currentPage === 1);
  }, [currentPage]);

  // 필터 변경 시 새로운 데이터 로드
  useEffect(() => {
    if (currentPage === 1) {
      getCouponList(0, true);
    } else {
      setCurrentPage(1);
    }
  }, [usageFilter]);

  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="100%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileTable={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          쿠폰 리스트
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="10px"
        >
          {/* 필터 및 버튼 영역 */}
          <DivStyle
            display="flex"
            flex_direction="row"
            align_items="center"
            marginTop="20px"
            marginLeft="20px"
            marginBottom="10px"
          >
            {/* 사용여부 필터 */}
            <DivStyle display="flex" align_items="center" marginRight="20px">
              <label
                style={{
                  color: "white",
                  marginRight: "10px",
                  fontSize: "14px",
                }}
              >
                사용여부:
              </label>
              <select
                value={usageFilter}
                onChange={(e) => handleFilterChange(e.target.value)}
                style={{
                  backgroundColor: "#2C2C2C",
                  color: "white",
                  border: "1px solid #444",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  fontSize: "14px",
                }}
              >
                <option value="all">전체</option>
                <option value="used">사용</option>
                <option value="unused">미사용</option>
              </select>
            </DivStyle>

            {/* 엑셀 다운로드 버튼 */}
            <ButtonStyle
              fontWeight="700"
              backgroundColor="#1976D2"
              border="none"
              borderRadius="7px"
              width="85px"
              height="40px"
              color="white"
              onClick={() => exportToExcel(headers)}
            >
              TOEXCEL
            </ButtonStyle>
          </DivStyle>

          <Table
            headers={headers}
            currentPage={currentPage}
            dataList={list}
            size={20}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={list}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default GameCouponList;
